import {InspectionType} from '@dms/api/core';

export type CreateAuditRequestBody = {
  inspectionType: InspectionType;
  auditStructureId?: string | null;
  auditId?: string | null;
  alreadySync?: boolean;
  inspectionName?: string | null;
};
